"use client";

import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [showButton, setShowButton] = useState(false);

    const handleScroll = () => {
        setShowButton(window.scrollY > 200);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            {showButton && (
                <div
                    onClick={scrollToTop}
                    className="fixed bottom-24 right-5 bg-[#000080] w-16 h-16 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-600 transition shadow-lg z-50"
                >
                    <FontAwesomeIcon icon={faChevronUp} className="text-white text-4xl" />
                </div>
            )}
        </>
    );
};

export default ScrollToTopButton;
